import React, { useState } from "react";
import PropTypes from "prop-types";
import Icon from "@mui/material/Icon";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import * as Func from "services/Function";

function MenuCollap({ row, btnAdd, btnEdit, btnDel, menuActive }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const enableDisplay = (inp) => {
    if (inp === 1) return <Icon color="info">verified</Icon>;
    return <Icon color="error">not_interested</Icon>;
  };

  return (
    <>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell align="center">{row.main_menu_id}</TableCell>
        <TableCell align="left">{row.key_id}</TableCell>
        <TableCell align="left">{row.main_menu_name}</TableCell>
        <TableCell align="left">{row.main_menu_name_en}</TableCell>
        <TableCell align="center">{row.weight}</TableCell>
        <TableCell align="center">{enableDisplay(row.enable)}</TableCell>
        <TableCell align="center">{Func.dateTimeDisplay(row.created_at)}</TableCell>
        <TableCell align="center">{Func.dateTimeDisplay(row.updated_at)}</TableCell>
        <TableCell align="center">{btnEdit(row)}</TableCell>
        <TableCell align="center">{btnDel(row)}</TableCell>
      </TableRow>

      <TableRow sx={{ bgcolor: "#f5f5f5" }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
          <Collapse in={menuActive === row.main_menu_id ? true : open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">{t(`attr.code`)}</TableCell>
                    <TableCell align="left">{t(`attr.id`)}</TableCell>
                    <TableCell align="left">{t(`attr.name_th`)}</TableCell>
                    <TableCell align="left">{t(`attr.name_en`)}</TableCell>
                    <TableCell align="center">{t(`attr.sort`)}</TableCell>
                    <TableCell align="center">{t(`attr.enable`)}</TableCell>
                    <TableCell align="center">{t(`attr.date_create`)}</TableCell>
                    <TableCell align="center">{t(`attr.date_update`)}</TableCell>
                    <TableCell />
                    <TableCell align="center">{btnAdd(row.main_menu_id)}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.menu
                    ? row.menu.map((item) => (
                        <TableRow key={item.menu_id}>
                          <TableCell align="center">{item.menu_id}</TableCell>
                          <TableCell align="left">{item.key_id}</TableCell>
                          <TableCell align="left">{item.menu_name}</TableCell>
                          <TableCell align="left">{item.menu_name_en}</TableCell>
                          <TableCell align="center">{item.weight}</TableCell>
                          <TableCell align="center">{enableDisplay(item.enable)}</TableCell>
                          <TableCell align="center">
                            {Func.dateTimeDisplay(item.created_at)}
                          </TableCell>
                          <TableCell align="center">
                            {Func.dateTimeDisplay(item.updated_at)}
                          </TableCell>
                          <TableCell align="center">{btnEdit(item, true)}</TableCell>
                          <TableCell align="center">{btnDel(item, true)}</TableCell>
                        </TableRow>
                      ))
                    : null}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

MenuCollap.propTypes = {
  row: PropTypes.shape({
    main_menu_id: PropTypes.number.isRequired,
    key_id: PropTypes.string.isRequired,
    main_menu_name: PropTypes.string.isRequired,
    main_menu_name_en: PropTypes.string.isRequired,
    weight: PropTypes.number.isRequired,
    enable: PropTypes.number.isRequired,
    created_at: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
    menu: PropTypes.arrayOf(
      PropTypes.shape({
        menu_id: PropTypes.number.isRequired,
        key_id: PropTypes.string.isRequired,
        menu_name: PropTypes.string.isRequired,
        menu_name_en: PropTypes.string.isRequired,
        weight: PropTypes.number.isRequired,
        enable: PropTypes.number.isRequired,
        created_at: PropTypes.string.isRequired,
        updated_at: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  btnAdd: PropTypes.func.isRequired,
  btnEdit: PropTypes.func.isRequired,
  btnDel: PropTypes.func.isRequired,
  menuActive: PropTypes.number.isRequired,
};

export default MenuCollap;
